import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import CookieBanner from "@/components/CookieBanner";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import { I18nProvider } from "@/i18n/I18nProvider";

const Layout = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [location.pathname]);

  return (
    <I18nProvider>
      <div className="min-h-screen flex flex-col bg-[#F4F0E8]">
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <CookieBanner />
        <AnnouncementBanner />
      </div>
    </I18nProvider>
  );
};

export default Layout;
